export interface DashboardState {
  loading: boolean;
  loaded: boolean;
  initialLoaded: boolean;
  error?: string;
  sumPnlToday: number;
  averagePnl30Days: number;
}

export const initialDashboardState: DashboardState = {
  loading: false,
  initialLoaded: false,
  loaded: false,
  error: undefined,
  sumPnlToday: 0,
  averagePnl30Days: 0
};
